import styled from "@emotion/styled";

export const Error = styled.p`
  color: red;
`;
